import { render, staticRenderFns } from "./Firm.vue?vue&type=template&id=b94a4806&scoped=true&"
import script from "./Firm.vue?vue&type=script&lang=js&"
export * from "./Firm.vue?vue&type=script&lang=js&"
import style0 from "./Firm.vue?vue&type=style&index=0&id=b94a4806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94a4806",
  null
  
)

export default component.exports